import { Tag, TagLabel, Box, Tooltip, TagProps } from '@chakra-ui/react';

import { EUSSStatus, ITag } from 'api-paths-cas';
import { EUSSIndicator } from '../../../atoms/icons/EUSSIndicator';

export const EussGrantedTag = ({ tag, tagProps }: { tag: ITag; tagProps?: TagProps }) => {
  return (
    <Tooltip hasArrow placement="bottom" label={<EUSSGrantedHover eussStatus={tag.eussStatus!} />}>
      <Tag size="xs" variant="solid" data-selector="tag-euss-granted" {...tagProps}>
        <Box mr="0.5">
          <EUSSIndicator />
        </Box>

        <TagLabel>{tag.label}</TagLabel>
      </Tag>
    </Tooltip>
  );
};

const EUSSGrantedHover = ({ eussStatus }: { eussStatus: EUSSStatus }) => {
  return (
    <>
      Status granted under EU Settlement Scheme: <br />
      <b>{eussStatus}</b>
    </>
  );
};
